import { MstMaintenanceTmpl } from '@libs/templates/mst';
import type { ItemName, PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { AdditionalInfo, locationMstColumns } from './components';
import { locationMstListSearchFieldConfig } from './item-config';
import { LocationMstListSearch } from './models';
import { doExport, listRequest, remove } from './repositories';

function PageComponent(props: PageProps & { itemName: ItemName }) {
  return (
    <MstMaintenanceTmpl
      mstName={props.itemName}
      columns={locationMstColumns}
      items={locationMstListSearchFieldConfig}
      listRequestFunction={listRequest}
      initMst={LocationMstListSearch.init}
      exportFunction={doExport}
      deleteFunction={remove}
      {...props}
    >
      {AdditionalInfo}
    </MstMaintenanceTmpl>
  );
}

const Maintenance = withRerender(PageComponent, 'Maintenance');

export { Maintenance };
